import { render, staticRenderFns } from "./orderLegendPopover.vue?vue&type=template&id=f891c4ac&scoped=true&"
import script from "./orderLegendPopover.vue?vue&type=script&lang=js&"
export * from "./orderLegendPopover.vue?vue&type=script&lang=js&"
import style0 from "./orderLegendPopover.vue?vue&type=style&index=0&id=f891c4ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f891c4ac",
  null
  
)

export default component.exports